import { defineStore } from "pinia";
import { TeamStory } from "@/services/entities/teamStory";
import TeamStoryDataFetcher from "@/services/connectors/teamStoryConnector";
import { getServerUrl } from "@/common/urls";

const teamStoryDataFetcher = new TeamStoryDataFetcher(getServerUrl());

export const useTeamStoryStore = defineStore("teamStory", {
    state: () => ({
        // Define your state properties here
        teamStoryData: [] as TeamStory[],
        template: {} as TeamStory,
        isLoading: false,
        error: null,
    }),

    actions: {
        async loadTeamStory(templateIdOrTargetId: string) {
            try {
                this.isLoading = true;
                this.error = null;

                this.teamStoryData = await teamStoryDataFetcher.getTeamStory(templateIdOrTargetId);
                this.teamStoryData.map((teamStory) => {
                    teamStory.tags = JSON.parse(teamStory.tags);
                });

                this.isLoading = false;
            } catch (error: any) {
                this.isLoading = false;
                this.error = error.message;
            }
        },

        async loadTemplate(templateId: string) {
            try {
                this.isLoading = true;
                this.error = null;

                this.template = await teamStoryDataFetcher.getTemplate(templateId);

                this.isLoading = false;
            } catch (error: any) {
                this.isLoading = false;
                this.error = error.message;
            }
        },

        async loadRecord(recordId: string) {
            try {
                this.isLoading = true;
                this.error = null;
                this.teamStoryData = [await teamStoryDataFetcher.getRecord(recordId)];
                this.teamStoryData.map((teamStory) => {
                    teamStory.tags = JSON.parse(teamStory.tags);
                });
                this.isLoading = false;
            } catch (error: any) {
                this.isLoading = false;
                this.error = error.message;
            }
        },

        // Define other actions here
        // For example:
        async updateTeamStory(newTeamStoryData: TeamStory) {
            try {
                this.isLoading = true;
                this.error = null;
                newTeamStoryData.tags = JSON.stringify(newTeamStoryData.tags);

                await teamStoryDataFetcher.updateTeamStory(newTeamStoryData);

                this.isLoading = false;
            } catch (error: any) {
                this.isLoading = false;
                this.error = error.message;
                throw error;
            }
        },

        async createTeamStory(targetCode: string, newTeamStoryData: TeamStory) {
            try {
                this.isLoading = true;
                this.error = null;
                newTeamStoryData.tags = JSON.stringify(newTeamStoryData.tags);

                await teamStoryDataFetcher.createTeamStory(targetCode, newTeamStoryData);

                this.isLoading = false;
            } catch (error: any) {
                this.isLoading = false;
                this.error = error.message;
            }
        },
    },
    getters: {
        getTeamStories(): TeamStory[] {
            return this.teamStoryData;
        },
        getLoadingStatus(): boolean {
            return this.isLoading;
        },
        getTemplate(): TeamStory {
            return this.template;
        },
    },
});
